export default class KlevuSearchProductCard {
  constructor (productData) {
    this.productData = productData;
    this.el = null;
  }

  async createProductCard () {
    const productData = this.productData;

    const templateProductCard = document.getElementById('templateSearchOverlayProductCard')
    const clone = document.importNode(templateProductCard.content, true)
    const productCard = clone.querySelector('[data-search-overlay-product-card]')

    const imageEl = productCard.querySelector('[data-search-overlay-product-card-el="image"]')
    const hoverImageEl = productCard.querySelector('[data-search-overlay-product-card-el="hoverImage"]')
    const titleEl = productCard.querySelector('[data-search-overlay-product-card-el="title"]')
    const linkEl = productCard.querySelector('[data-search-overlay-product-card-el="link"]')
    const quickAddTriggerEl = productCard.querySelector('[data-search-overlay-product-card-el="quickAddTrigger"]')
    const productHandle = productData.url.split('/').pop()

    imageEl.src = productData.image.replace('_medium', '_grande')
    imageEl.alt = productData.name
    hoverImageEl.src = productData.imageHover.replace('_medium', '_grande') || productData.image.replace('_medium', '_grande')
    hoverImageEl.alt = productData.name
    titleEl.textContent = productData.name
    linkEl.href = productData.url
    quickAddTriggerEl.setAttribute('data-product-handle', productHandle)

    const productPriceHTML = await this.fetchProductPrice(productHandle);
    const priceEl = productCard.querySelector('[data-search-overlay-product-card-el="price"]')

    priceEl.innerHTML = productPriceHTML;

    this.el = clone
    this.addProductCardEventListeners()

    return clone
  }

  addProductCardEventListeners () {
    const quickAddOpenTriggerEls = this.el.querySelectorAll('[data-search-overlay-product-card-el="quickAddTrigger"]')

    quickAddOpenTriggerEls.forEach(trigger => {
      trigger.addEventListener('click', (event) => {
        this.handleOpenQuickAdd(event);
      });
    });
  }

  handleOpenQuickAdd (event) {
    event.preventDefault();

    const target = event.currentTarget;
    const hasBeenInitialised = target.getAttribute('data-initialised') === 'true';

    if (hasBeenInitialised) {
      const quickAddFormWrapperEl = target.closest('[data-search-overlay-product-card-el="quickAddWrapper"]');
      quickAddFormWrapperEl.setAttribute('aria-hidden', 'false');
    } else {
      this.renderQuickAddForm(target);
    }
  }

  async renderQuickAddForm (target) {
    const quickAddForm = await this.fetchQuickAddForm(target);

    if (!quickAddForm) return

    const productCard = target.closest('[data-search-overlay-product-card]');
    const quickAddFormWrapperEl = productCard.querySelector('[data-search-overlay-product-card-el="quickAddWrapper"]');

    quickAddFormWrapperEl.innerHTML = '';
    quickAddFormWrapperEl.appendChild(quickAddForm);
    quickAddFormWrapperEl.setAttribute('aria-hidden', 'false');

    this.addQuickAddEventListeners(quickAddFormWrapperEl)
  }

  fetchQuickAddForm (target) {
    const productHandle = target.getAttribute('data-product-handle');

    return fetch(`/products/${productHandle}?section_id=search-overlay-quick-add-form`)
      .then(response => {
        if (!response.ok) throw new Error('Failed to fetch quick add section');
        return response.text();
      })
      .then(text => {
        const html = new DOMParser().parseFromString(text, 'text/html');
        return html.querySelector('[data-search-overlay-product-card-el="quickAddForm"]');
      });
  }

  fetchProductPrice (productHandle) {
    return fetch(`${window.Shopify.routes.root}products/${productHandle}?section_id=product-price`)
      .then(response => {
        if (!response.ok) throw new Error('Failed to fetch product price');
        return response.text();
      })
      .then(text => {
        const result = new DOMParser().parseFromString(text, 'text/html');
        const resultHTML = result.getElementById('shopify-section-product-price').innerHTML;

        return resultHTML;
      });
  }

  addQuickAddEventListeners (quickAddWrapper) {
    const quickAddCloseTriggerEl = quickAddWrapper.querySelector('[data-close-quick-add]')

    quickAddCloseTriggerEl.addEventListener('click', (event) => {
      this.handleCloseQuickAdd(event);
    });

    const quickAddFormEl = quickAddWrapper.querySelector('form')

    quickAddFormEl.addEventListener('submit', (event) => {
      this.handleQuickAddToCart(event);
    });
  }

  handleCloseQuickAdd (event) {
    const quickAddWrapper = event.target.closest('[data-search-overlay-product-card-el="quickAddWrapper"]')
    quickAddWrapper.setAttribute('aria-hidden', 'true')
  }

  handleQuickAddToCart(event) {
    event.preventDefault();

    const form = event.target.closest('form')
    const formSelectEl = form.querySelector('[data-search-overlay-form-el="select"]');
    const selectedOption = formSelectEl.options[formSelectEl.selectedIndex];
    const variantId = selectedOption.dataset.variantId;

    let formData = {
      'items': [{
        'id': variantId,
        'quantity': 1
      }]
    };

    window.Cart.add(formData);
  }
}
